export const BUILDPC_V3_LOCAL_STORAGE_KEY = 'buildPc3';

export const BUILD_PC_MODAL_PAGE_SIZE = 20;

export const DEFAULT_PRICE_FILTER = { gte: 0, lte: 1000000000 };

export const CPU_CATEGORY_ID = '553';

export const MAIN_BOARD_CATEGORY_ID = '552';

export const CPU_CATEGORY_NAME = 'CPU';

export const MAIN_BOARD_CATEGORY_NAME = 'MAINBOARD';

export const SOCKET_ATTRIBUTE_GROUPS_ID = [6199, 8360];

export const CPU_SOCKET_ATTRIBUTE_CODE = 'attributes.cpu_socket';

export const MAIN_BOARD_SOCKET_ATTRIBUTE_CODE = 'attributes.mainboard_socket';
